import logoUrl from '/unlimit-logo.png?url';

interface UnlimitLogoProps {
  className?: string;
  size?: number;
}

export function UnlimitIcon({ className = '', size = 32 }: UnlimitLogoProps) {
  return (
    <img
      src={logoUrl}
      alt="Unlimit"
      width={size}
      height={size}
      className={`rounded-lg ${className}`}
    />
  );
}

export function UnlimitWordmark({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 60"
      fill="currentColor"
      className={className}
      aria-label="unlimit"
    >
      <path d="M0 45.5V8h12.5v37.5c0 5.5 3.5 9 9 9s9-3.5 9-9V8H43v37.5C43 56.5 33.5 60 21.5 60S0 56.5 0 45.5z" />
      <path d="M52 20h12v4.5c3-3.5 7.5-5.5 12.5-5.5 9 0 15.5 6.5 15.5 16V59H79.5V37c0-4.5-3-7.5-7.5-7.5S64.5 32.5 64.5 37v22H52V20z" />
      <path d="M100 0h12.5v59H100V0z" />
      <path d="M122 20h12.5v39H122V20zm6.25-5.5a7 7 0 110-14 7 7 0 010 14z" />
      <path d="M143 20h12v4.5c2.5-3.5 6.5-5.5 11-5.5 5 0 9 2.5 11 6 3-3.5 7.5-6 13-6 9 0 14.5 6.5 14.5 16V59h-12.5V37c0-4.5-2.5-7.5-6.5-7.5s-7 3-7 7.5v22h-12.5V37c0-4.5-2.5-7.5-6.5-7.5s-7 3-7 7.5v22H143V20z" />
      <path d="M213 20h12.5v39H213V20zm6.25-5.5a7 7 0 110-14 7 7 0 010 14z" />
      <path d="M238 20h4v-9h12.5v9h7v10h-7v17.5c0 2 1 3 3 3h4V59c-2 1-4.5 1-6.5 1-8 0-13-4-13-12.5V30h-4V20z" />
    </svg>
  );
}
